// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(H)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd HH:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d H:m:s.S")      ==> 2006-7-2 8:9:4.18
function getformatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

function padLeftZero (str) {
  return ('00' + str).substr(str.length);
};

// 时间戳转时分秒
export const tsDate = function (time) {
  return getformatDate(new Date(time), 'yyyy-MM-dd hh:mm');
};

export const date = function (value, formatString) {
  formatString = formatString || 'yyyy-MM-dd';
  const date = new Date(value);
  return getformatDate(date, formatString);
};

export const time = function (value, formatString) {
  formatString = formatString || 'hh:mm:ss';
  const date = new Date(value);
  return getformatDate(date, formatString);
};

export const dateTime = function (value, formatString) {
  formatString = formatString || 'yyyy-MM-dd hh:mm:ss';
  const date = new Date(value);
  return getformatDate(date, formatString);
};



// WEBPACK FOOTER //
// ./src/filters/formatDate.js